import { Company } from './types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const companiesState = (state: RootState): RootState['companies'] => state.companies;

export const companiesData = createSelector(
  companiesState,
  (state: RootState['companies']): Company[] | null => state.data,
);

export const companiesLoading = createSelector(
  companiesState,
  (state: RootState['companies']): boolean => state.loading,
);
